import { createAction } from 'redux-actions'
import {
  GET_FORM_DATA,
  GET_FORM_DATA_FAILED,
  GET_FORM_DATA_SUCCEEDED,
  GET_REQUEST_PROMO_CODE,
  GET_REQUEST_PROMO_CODE_FAILED,
  GET_REQUEST_PROMO_CODE_SUCCEEDED,
} from 'Redux/Types/SignupTypes'

export const getFormData = createAction(GET_FORM_DATA)
export const getFormDataFailed = createAction(GET_FORM_DATA_FAILED)
export const getFormDataSucceeded = createAction(GET_FORM_DATA_SUCCEEDED)

export const getRequestPromoCode = createAction(GET_REQUEST_PROMO_CODE)
export const getRequestPromoCodeFailed = createAction(GET_REQUEST_PROMO_CODE_FAILED)
export const getRequestPromoCodeSucceeded = createAction(GET_REQUEST_PROMO_CODE_SUCCEEDED)
